import React from 'react';
import { matchPath, Redirect } from 'react-router-dom';
import { 
  Paths 
} from '../../dispatcher/authentication/interfaces/AuthInterface';
import Configuration from '../../dispatcher/config/Configuration';
import Route, { ROUTE_PREFIX } from './Route';
import _ from 'lodash';
import { Service } from '../../dispatcher/services/Service';
import AuthService from '../../dispatcher/authentication/services/AuthService';

export type NavigationProps = {
    config: Paths[];
    defaultRoute?: string;
    children?: any[];
    forceUseOfDefaultRoute?: boolean; // if `true` then redirect will go to defaultRoute instead of previous route
};

class RouterUtil extends Service {
  private static _instance: any;

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  constructor() {
    super();
    this.registerServiceToDispatcher();
  }

  public static routeConfig: any = [];
    public static addRoutes = routes => RouterUtil.routeConfig.push(routes);

    public static pathPrefix: string = 'view'
    public static makePath = (path: string): string => {
      path = path.replace(/^\//, '');
      path = path.replace(/\/$/, '');

      return `/${RouterUtil.pathPrefix}/${path}`;
    }

    /**
     * Generates route for passed configuration.
     * @param pathConfig
     * @param index
     */
    public static mapRoute = (pathConfig: Paths, index: number) => {
      let routeKey = _.get(pathConfig, 'routeKey', `${index}`);
      pathConfig.routeKey = routeKey;

      return (
        <Route
          key={RouterUtil.getWrapperRouteKeyName(routeKey)}
          {...pathConfig}
        />);
    };

    /**
     * Forming key for wrapper route.
     * @param key
     */
    public static getWrapperRouteKeyName = (key: string): string => `${ROUTE_PREFIX}${key}-wrapper`;

    /**
     * Renders redirect route
     * @param {string} from
     * @param {boolean} exact
     * @param {string} defaultRoute
     */
    public static redirectRoute(from, exact = false, defaultRoute?) : any {
      let to = AuthService.getLandingUri();
      if (!to) {
        to = defaultRoute;
      }
      return (
        <Redirect
          from={from}
          exact={exact}
          to={to}
        />
      );
    }

    /**
     * Renders BaseNavigation children components
     * @param {any} children
     */
    public static renderChildren = (children) => {
      let filteredChildren: any[] = children.filter((child: any) => child);
      return filteredChildren.map((child: any) => child);
    };

    /**
     * Renders BaseNavigation routes
     * @param {any} config
     */
    public static renderRoutes = config => config.map((path: Paths, index: number) => RouterUtil.mapRoute(path, index));

    /**
     * Returns true if pathName from url matches some of predefined route, false otherwise
     */
    public static matchRoute = (routeConfig?) => {
      const pathName: string = Configuration.getPathname();
      let matchRoute = false;
      let current;
      let config = routeConfig ? routeConfig : RouterUtil.routeConfig;
      let item = config.length;
      while (!matchRoute && item--) {
        current = config[item];
        matchRoute = !!matchPath(pathName, current);
      }

      return matchRoute;
    };
}

export default RouterUtil;
